module.exports = __webpack_public_path__ + "static/media/close.92d85624.svg";